<template>
  <div class="staff-management" style="padding:16px">
    <el-card class="card-container">
      <div slot="header" class="clearfix">
        <span>{{ $route.meta.title || '券码核销' }}</span>
      </div>
      <el-form ref="formreset" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="券码：" prop="card_no">
          <el-input v-model="card_no" placeholder="请输入要核销的券码"></el-input>
        </el-form-item>
        <el-button type="danger" @click="saveCancel">确认核销</el-button>
      </el-form>
    </el-card>
    <div style="height:8px; background: #edeff2"></div>
    <div style="height:8px; background: #edeff2"></div>
    <el-card class="card-container">
      <el-table
        ref="multipleTable"
        v-loading="tableLoading"
        :data="tableData"
        max-height="500"
        style="width: 100%;margin-top:10px;"
      >
        >
        <!-- <el-table-column prop="j obNo" label="工号" />-->
        <el-table-column prop="card_name" label="装修券名称" min-width="130" />
        <el-table-column prop="card_no" label="券码" min-width="100" />
        <el-table-column prop="user_phone" label="业主手机号" min-width="100" />
        <el-table-column prop="user_wx_name" label="业主微信号" min-width="130" />
        <el-table-column prop="check_date" label="核销时间" min-width="100" />
        <el-table-column prop="check_by" label="核销人" min-width="100" />
        <el-table-column prop="status" label="核销状态" min-width="100">
          <template slot-scope="scope">
            {{ scope.row.status == 1 ? '待核销' : '已核销' }}
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination" style="width:100%;text-align:center">
        <el-pagination
          style="text-align: right"
          :current-page="page"
          :page-sizes="[10, 20, 30, 50, 100]"
          :page-size="limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import ticket from '@/api/ticket';
import { export_json_to_excel } from '@/excel/Export2Excel';
export default {
  name: 'clueClient',
  components: {},
  data() {
    return {
      card_no: '', //核销码
      rowData: {},
      tableData: [],
      tableLoading: false,
      page: 1, // 分页面数
      limit: 10, // 分页条数
      total: 0,
      exportLoading: false,
      exportData: [],
    };
  },
  mounted() {
    this.handleSearch();
  },
  methods: {
    async saveCancel() {
      if (!this.card_no) {
        this.$message.error('请输入要核销的码');
        return;
      }
      const res = await ticket.ticketCancelCheck({ card_no: this.card_no });
      if (res && res.status === 200 && res.data.error_code === 0) {
        this.$message.success("核销成功");
        this.card_no="";
        this.handleSearch()
      } else {
        this.$message.error(res.data.error_msg);
      }
    },
    // 搜索
    handleSearch() {
      this.page = 1;
      this._queryTableList();
    },
    async _queryTableList() {
      const params = {
        page: this.page,
        limit: this.limit,
      };
      this.tableLoading = true;
      const res = await ticket.ticketList(params);
      if (res && res.status === 200 && res.data.error_code === 0) {
        this.tableLoading = false;
        this.tableData = res.data.data.list || [];
        this.total = res.data.data.page.total_number || 0;
        this.tableLoading = false;
      } else {
        this.$message.error(res.data.error_msg);
        this.tableLoading = false;
      }
    },
    // 重置
    reset() {
      this.$refs.formreset.resetFields();
      this.page = 1;
      this.total = 0;
      this.handleSearch();
    },
    // 修改一页大小
    handleSizeChange(val) {
      this.page = 1;
      this.limit = val;
      this._queryTableList();
    },
    // 第几页
    handleCurrentChange(val) {
      this.page = val;
      this._queryTableList();
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    handleExport() {
      this.exportLoading = true;
      const tHeader = ['订单时间', '业主姓名', '手机号码', '城市', '区县', '面积', '特殊需求'];
      // 上面设置Excel的表格第一行的标题
      const filterVal = ['create_date', 'name', 'tel', 'city_name', 'area_name', 'mianji', 'text'];
      this.fetchExportOrders('export', () => {
        const list = this.exportData; // 把data里的exportData存到list
        this.exportData = [];
        const data = this.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, '活动订单列表');
        this.exportLoading = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.staff-management {
  min-height: 1100px;
  overflow: auto;
  .pagination {
    margin: 8px 0;
    float: right;
  }
}
.active {
  color: #008000;
}
.inactive {
  color: #ff0000;
}
</style>
